import type { ReactElement } from 'react';
import React from 'react';

export default function DiagonalHatchPattern(): ReactElement {
  const gap = 8; // Width of gap between each diagonal line.

  return (
    <defs>
      <pattern id="diagonal-hatch" patternUnits="userSpaceOnUse" width={gap} height={gap}>
        <path d={`M-1,1 l2,-2 M0,${gap} l${gap},-${gap} M3,5 l2,-2`} />
      </pattern>
    </defs>
  );
}
